import MergeForm from "./MergeForm";
import SplitForm from "./SplitForm";
import ImportSpatialDataPage from "./ImportSpatialData/ImportSpatialDataPage";
import PrintMapForm from "./jic print map/PrintMapForm";
export {
    MergeForm,
    SplitForm,
    ImportSpatialDataPage,
    PrintMapForm
}